<template>
  <div class="ht-device">
    <single-mod :mod="curMod" :valueOp="valueOp" :rightEchart="rightEchart" :imsVisible="true">
      <template v-slot="wsData">
        <div
          class="device-info"
          v-if="
            wsData.singleDeviceDetail &&
            wsData.singleDeviceDetail.mods &&
            wsData.singleDeviceDetail.mods[curMod]
          "
        >
          <el-row type="flex" align="middle">
            <el-col :span="12">
              <div>
                <span>设备名称:</span>
                <span>{{ wsData.singleDeviceDetail.name }}</span>
              </div>
              <div>
                <span>设备编号:</span>
                <span>{{ wsData.singleDeviceDetail.sn }}</span>
              </div>
              <div>
                <span>设备状态:</span>
                <span class="state" :class="wsData.singleDeviceDetail.state | stateClass(true)">
                  {{ wsData.singleDeviceDetail.state | stateText }}
                </span>
              </div>
              <div style="margin-bottom: 10px">
                <span>运行状态:</span>
                <span
                  class="state"
                  :class="wsData.singleDeviceDetail.runstate | runstateClass(true)"
                >
                  {{ wsData.singleDeviceDetail.runstate | runstateText }}
                </span>
              </div>
              <div>
                <span>温度:</span>
                <span>{{ wsData.singleDeviceDetail.mods[curMod].temp }}</span>
              </div>
              <div>
                <span>湿度:</span>
                <span>{{ wsData.singleDeviceDetail.mods[curMod].humidity }}</span>
              </div>
              <div>
                <span>气流:</span>
                <span>{{ wsData.singleDeviceDetail.mods[curMod].flow }}</span>
              </div>
              <div>
                <span>浓度:</span>
                <span>
                  {{ concentrations[wsData.singleDeviceDetail.mods[curMod].concentration] }}
                </span>
              </div>
              <div>
                <span>气体名称:</span>
                <span>{{ wsData.singleDeviceDetail.mods[curMod].gasName }}</span>
              </div>
            </el-col>
            <el-col :span="12" style="display: flex; align-items: center">
              <div
                style="
                  width: 100%;
                  margin: 0 auto;
                  display: flex;
                  justify-content: flex-end;
                  font-size: 26px;
                "
              >
                <ModsIcon
                  icon="icon-chemical-weapon"
                  :wsData="wsData.singleDeviceDetail"
                  :mods="curMod"
                />
              </div>
            </el-col>
          </el-row>
        </div>
      </template>
    </single-mod>
  </div>
</template>

<script>
import SingleMod from '../components/single-mod';
import ModsIcon from '@/components/mods-icon';
import { graColor } from '@/views/realdata/FCBR-100/options';
import { lineAreaStyle } from '@/echartOption/lineAreaStyle';
import { concentrations } from '@/utils/dict';

export default {
  name: 'HTDevice',
  components: {
    SingleMod,
    ModsIcon
  },
  data() {
    return {
      curMod: 'cwaMod',
      concentrations,
      valueOp: [
        {
          title: '正模式浓度(V)',
          key: 'sccell1RData'
        },
        {
          title: '负模式浓度(V)',
          key: 'sccell2RData'
        }
      ],
      rightEchart: [
        lineAreaStyle({
          color: '#833BBB',
          title: { text: '正模式浓度', left: 'center' },
          yAxis: { name: 'V' },
          series: [
            { areaStyle: { color: graColor('rgba(131, 59, 187, 0.5)', 'rgba(131, 59, 187, 0)') } }
          ]
        }),
        lineAreaStyle({
          color: '#3368F2',
          title: { text: '负模式浓度', left: 'center' },
          yAxis: { name: 'V' },
          series: [
            { areaStyle: { color: graColor('rgba(51, 104, 242, 0.5)', 'rgba(51, 104, 242, 0)') } }
          ]
        })
      ]
    };
  }
};
</script>

<style lang="scss">
.ht-device {
  height: 100%;
  .device-info {
    color: #00a0e9;
    font-size: 14px;
    .state {
      @include state-textstyle;
    }
    .el-row {
      > .el-col {
        > div {
          line-height: 22px;
          span {
            &:first-child {
              letter-spacing: 2px;
            }
          }
        }
      }
    }
  }
}
</style>
